import { ButtonIconSize } from '../../../../enums/buttons';
export const iconSizeStyles = `
  &.icon-size-${ButtonIconSize.Small} svg {
    height: 16px;
    width: 16px;
  }

  &.icon-size-${ButtonIconSize.Medium} svg {
    height: 22px;
    width: 22px;
  }

  &.icon-size-${ButtonIconSize.Large} svg {
    height: 25px;
    width: 25px;
  }
`;
